
type IVersion = IResponse.Version.IVersion;

import { Component, Vue } from "vue-property-decorator";
import { getHistorVersionById } from "@/api/version";
import moment from "moment";

@Component
export default class AppHistory extends Vue {
  public id: string = "";
  public appName: string = "";
  public platformText: string = "";
  public versions: IVersion[] = [];

  public columns = [
    {
      title: "Version",
      scopedSlots: { customRender: "version_detail" },
      key: "version_detail",
      width: "80%",
    },
    {
      title: "Action",
      scopedSlots: { customRender: "action" },
      key: "action",
      align: "right",
      width: "20%",
    },
  ];

  public created(): void {
    this.id = this.$route.query.id as string;
    this.appName = this.$route.query.appName as string;
    this.platformText = this.$route.query.platformText as string;
    this.fetchHistoryData(this.id);
  }

  public convertTime(time: string): string {
    if (time) {
      return moment(time).format("YYYY/MM/DD HH:mm");
    } else {
      return "-";
    }
  }

  public async fetchHistoryData(id: string): Promise<void> {
    const response = await getHistorVersionById(this.id);
    if (!response.status) {
      this.$message.error(response.message);
      return;
    }
    this.versions = response.list;
  }

  public previewVer(version: IVersion): void {
    const link = this.$router.resolve({ path: "/" + version.id });
    window.open(link.href, "_blank");
  }
}
